import _ from 'lodash';
import {useCallback, useEffect, useRef} from 'react';

// eslint-disable-next-line default-param-last
const useDebounce = (dependencies = [], func, timeout = 600) => {
  const lastDepsStateRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callFunc = useCallback(_.debounce(func, timeout), []);

  useEffect(() => {
    const isEqual = _.isEqual(lastDepsStateRef.current, dependencies);

    if (isEqual) return;

    lastDepsStateRef.current = dependencies;

    callFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useDebounce;
